import { render, staticRenderFns } from "./AbkMatchingToLaborMarketBox.vue?vue&type=template&id=346353b8&scoped=true&"
import script from "./AbkMatchingToLaborMarketBox.vue?vue&type=script&lang=js&"
export * from "./AbkMatchingToLaborMarketBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkMatchingToLaborMarketBox.vue?vue&type=style&index=0&id=346353b8&scoped=true&lang=scss&"
import style1 from "./AbkMatchingToLaborMarketBox.vue?vue&type=style&index=1&id=346353b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346353b8",
  null
  
)

export default component.exports